import func from "@uikit/func";
import { getIt } from "../uikit/getIt";
import { useDispatch } from "react-redux";
import { editorActions } from "../store/editor";
import { FotClient } from "imagica-corekit/dist/base/api/FotClient";
import { logEvent } from "@amplitude/analytics-browser";
import { sleep } from "../views/thinking-layout-editor/util";
import store from "../store";
import { uploadTypes } from "@uiview/views/Nodes/constants";

const useCotFlow = props => {
  const { setEnableTooltipWhatTodo, setShowTooltip, setCenter, setNodes } = props;
  const dispatch = useDispatch();
  const brainClient = getIt(FotClient);
  const setCotStore = val => {
    dispatch(editorActions.setCot(val));
  };

  const showAllInputs = async (saasInputNodeIds, saasNodes, index = 0) => {
    if (func.isEmpty(saasInputNodeIds) || func.isEmpty(saasNodes)) {
      func.messageUtil("Not found input node");
      return;
    }
    const show = async i => {
      const cotStore = store.getState().editor.cot;
      if (i >= saasInputNodeIds.length || !cotStore.creating) {
        // 结束
        setCotStore({
          creating: false,
          inputIds: saasInputNodeIds,
          currentInputId: "",
        });
        return;
      }
      const inputNode = saasNodes.find(x => x.id === saasInputNodeIds[i]);
      if (func.isEmpty(inputNode)) {
        func.messageUtil("Not found input node");
        return;
      }
      setCenter(inputNode.position.x + 250, inputNode.position.y + 100, { duration: 300, zoom: 1.2 });
      if (uploadTypes.includes(inputNode.data.displayType)) {
        return;
      }
      const result = await brainClient.cot.suggest(inputNode.data.placeholder);
      await setInputValueByWriter(inputNode.id, result?.suggested_input);
      await sleep(800);
      await show(i + 1);
    };

    // link: https://github.com/brain/micro-apps/pull/1761 去掉 tooltip
    setEnableTooltipWhatTodo(false);
    setShowTooltip("");

    await show(index);
  };

  const setInputValueByWriter = async (nodeId, fullText) => {
    logEvent("click_submit", fullText);
    const write = async i => {
      await sleep(20);
      const txt = fullText.slice(0, i);
      setNodes(prevList => {
        return prevList.map(l => {
          if (l.id === nodeId) {
            return {
              ...l,
              data: {
                ...l.data,
                textAreaValue: txt,
              },
            };
          }
          return l;
        });
      });
      if (i < fullText.length) {
        await write(i + 2);
      }
    };
    await write(1);
  };

  return {
    showAllInputs,
  };
};

export default useCotFlow;
